import { Component, OnInit } from '@angular/core';
import { TranslationLoaderFacade } from 'src/app/admin/localization/translation-loader.facade';

@Component({
  selector: 'app-lobby-staff-status',
  templateUrl: './lobby-staff-status.component.html',
  styleUrls: ['./lobby-staff-status.component.scss']
})
export class LobbyStaffStatusComponent implements OnInit {

  constructor(private translationLoaderFacade: TranslationLoaderFacade) { }

  ngOnInit() {
  }

}
